var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { href: "/adm/rotas" }
                  },
                  [_c("i", { staticClass: "fa fa-map" }), _vm._v(" Voltar")]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row", { staticClass: "mt-3" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Início da Rota")]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: { config: _vm.datePickerConfig },
                    model: {
                      value: _vm.dtinicio,
                      callback: function($$v) {
                        _vm.dtinicio = $$v
                      },
                      expression: "dtinicio"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Fim da Rota")]),
                  _vm._v(" "),
                  _c("date-picker", {
                    attrs: { config: _vm.datePickerConfig },
                    model: {
                      value: _vm.dtfim,
                      callback: function($$v) {
                        _vm.dtfim = $$v
                      },
                      expression: "dtfim"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _vm.listaRota.length > 0
            ? _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c(
                    "b-col",
                    { staticClass: "col-md-12" },
                    [
                      _c(
                        "b-card",
                        { attrs: { "no-body": "" } },
                        [
                          _c(
                            "b-tabs",
                            {
                              attrs: {
                                "active-nav-item-class":
                                  "font-weight-bold bg-primary text-secondary",
                                "active-tab-class": "font-weight-bold",
                                card: ""
                              },
                              model: {
                                value: _vm.tabEdit,
                                callback: function($$v) {
                                  _vm.tabEdit = $$v
                                },
                                expression: "tabEdit"
                              }
                            },
                            [
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: "Rotas",
                                    "title-link-class": "text-primary"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col-12 card p-3" },
                                      [
                                        _c(
                                          "table",
                                          { staticClass: "table table-hover" },
                                          [
                                            _c("thead", [
                                              _c("tr", [
                                                _c("th"),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("Endereco")]),
                                                _vm._v(" "),
                                                _c("th", [_vm._v("Cidade")])
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "tbody",
                                              _vm._l(_vm.orderedUsers, function(
                                                rota,
                                                i
                                              ) {
                                                return _c(
                                                  "tr",
                                                  { key: rota.id },
                                                  [
                                                    _c(
                                                      "td",
                                                      {
                                                        staticClass: "btn-group"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.addDetalhamento(
                                                                  rota.coordenadas,
                                                                  rota.cidade,
                                                                  rota.subrota,
                                                                  rota.km,
                                                                  rota.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-map-marker"
                                                            })
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn btn-primary",
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.removeRota(
                                                                  rota.id
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("i", {
                                                              staticClass:
                                                                "fas fa-trash"
                                                            })
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(rota.endereco)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("td", [
                                                      _vm._v(
                                                        _vm._s(rota.cidade)
                                                      )
                                                    ])
                                                  ]
                                                )
                                              }),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c("tfoot", [
                                              _c(
                                                "tr",
                                                { staticClass: "text-primary" },
                                                [
                                                  _c("td", [
                                                    _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn btn-primary",
                                                        on: {
                                                          click:
                                                            _vm.confirmaRota
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                        Salvar\n                                                    "
                                                        )
                                                      ]
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td", [
                                                    _vm._v(
                                                      "Total Km " +
                                                        _vm._s(_vm.totalKM)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("td")
                                                ]
                                              )
                                            ])
                                          ]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row mt-3" }, [
                                    _c("div", { staticClass: "col-12" }, [
                                      _c("h3", { staticClass: "text-info" }, [
                                        _vm._v("Definindo rotas")
                                      ]),
                                      _vm._v(" "),
                                      _c("label", [
                                        _vm._v("Informe o endereço do Hotel.")
                                      ]),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.busca,
                                            expression: "busca"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: { type: "text" },
                                        domProps: { value: _vm.busca },
                                        on: {
                                          keyup: _vm.getAddress,
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.busca = $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.listaBusca.length > 0
                                        ? _c(
                                            "div",
                                            { staticClass: "list-group" },
                                            _vm._l(_vm.listaBusca, function(
                                              list,
                                              index
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "list-group-item"
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: { href: "#" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addRota(
                                                            list.coordenadas
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(index + 1) +
                                                          " - " +
                                                          _vm._s(list.endereco)
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        : _vm._e()
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-tab",
                                {
                                  attrs: {
                                    title: "Sub Rotas",
                                    "title-link-class": "text-primary"
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _vm.listaSubRota.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "col-md-12" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "list-group" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "list-group-item active"
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-map-pin"
                                                    }),
                                                    _vm._v(
                                                      " Sub Rotas\n                                        "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "list-group-item"
                                                  },
                                                  [
                                                    _c(
                                                      "table",
                                                      {
                                                        staticClass:
                                                          "table table-hover"
                                                      },
                                                      [
                                                        _c("thead", [
                                                          _c("tr", [
                                                            _c("td", [
                                                              _vm._v("Endereço")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v("Cidade")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v("Data")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v("Objetivo")
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v("Cliente")
                                                            ])
                                                          ])
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "tbody",
                                                          _vm._l(
                                                            _vm.orderSubrota,
                                                            function(
                                                              list,
                                                              idx
                                                            ) {
                                                              return _c(
                                                                "tr",
                                                                { key: idx },
                                                                [
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        list.endereco
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        list.cidade
                                                                      )
                                                                    )
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    !list.id
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form-group"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "date-picker",
                                                                              {
                                                                                attrs: {
                                                                                  config:
                                                                                    _vm.datePickerConfig
                                                                                },
                                                                                model: {
                                                                                  value:
                                                                                    list.dtlocal,
                                                                                  callback: function(
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      list,
                                                                                      "dtlocal",
                                                                                      $$v
                                                                                    )
                                                                                  },
                                                                                  expression:
                                                                                    "list.dtlocal"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    list.dtlocal
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  list.dtlocal
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    !list.id
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form-group"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "select",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      list.tipo,
                                                                                    expression:
                                                                                      "list.tipo"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "form-control",
                                                                                on: {
                                                                                  change: function(
                                                                                    $event
                                                                                  ) {
                                                                                    var $$selectedVal = Array.prototype.filter
                                                                                      .call(
                                                                                        $event
                                                                                          .target
                                                                                          .options,
                                                                                        function(
                                                                                          o
                                                                                        ) {
                                                                                          return o.selected
                                                                                        }
                                                                                      )
                                                                                      .map(
                                                                                        function(
                                                                                          o
                                                                                        ) {
                                                                                          var val =
                                                                                            "_value" in
                                                                                            o
                                                                                              ? o._value
                                                                                              : o.value
                                                                                          return val
                                                                                        }
                                                                                      )
                                                                                    _vm.$set(
                                                                                      list,
                                                                                      "tipo",
                                                                                      $event
                                                                                        .target
                                                                                        .multiple
                                                                                        ? $$selectedVal
                                                                                        : $$selectedVal[0]
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "option",
                                                                                  {
                                                                                    attrs: {
                                                                                      value:
                                                                                        "PROSPECTO"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Prospecto"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "option",
                                                                                  {
                                                                                    attrs: {
                                                                                      value:
                                                                                        "RECUPERACAO"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                                                        Recuperação\n                                                                    "
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "option",
                                                                                  {
                                                                                    attrs: {
                                                                                      value:
                                                                                        "NEGOCIACAO"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Negociação"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "option",
                                                                                  {
                                                                                    attrs: {
                                                                                      value:
                                                                                        "OUTROS"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Outros"
                                                                                    )
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "option",
                                                                                  {
                                                                                    attrs: {
                                                                                      value:
                                                                                        "HOTEL"
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "Hotel"
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    list.tipo
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  list.tipo
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    !list.id
                                                                      ? _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "form-group"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "input",
                                                                              {
                                                                                directives: [
                                                                                  {
                                                                                    name:
                                                                                      "model",
                                                                                    rawName:
                                                                                      "v-model",
                                                                                    value:
                                                                                      list.nome,
                                                                                    expression:
                                                                                      "list.nome"
                                                                                  }
                                                                                ],
                                                                                staticClass:
                                                                                  "form-control",
                                                                                attrs: {
                                                                                  type:
                                                                                    "text"
                                                                                },
                                                                                domProps: {
                                                                                  value:
                                                                                    list.nome
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    if (
                                                                                      $event
                                                                                        .target
                                                                                        .composing
                                                                                    ) {
                                                                                      return
                                                                                    }
                                                                                    _vm.$set(
                                                                                      list,
                                                                                      "nome",
                                                                                      $event
                                                                                        .target
                                                                                        .value
                                                                                    )
                                                                                  }
                                                                                }
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    list.nome
                                                                      ? _c(
                                                                          "div",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                                                " +
                                                                                _vm._s(
                                                                                  list.nome
                                                                                ) +
                                                                                "\n                                                            "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "form-group"
                                                                      },
                                                                      [
                                                                        _vm
                                                                          .listaSubRota
                                                                          .length >
                                                                          0 &&
                                                                        list.id ===
                                                                          0
                                                                          ? _c(
                                                                              "button",
                                                                              {
                                                                                staticClass:
                                                                                  "btn btn-primary",
                                                                                on: {
                                                                                  click: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.addArraySubRota(
                                                                                      idx,
                                                                                      list.nome,
                                                                                      list.dtlocal,
                                                                                      list.tipo
                                                                                    )
                                                                                  }
                                                                                }
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-plus-circle"
                                                                                  }
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _vm
                                                                          .listaSubRota
                                                                          .length >
                                                                          0 &&
                                                                        list.id >
                                                                          0
                                                                          ? _c(
                                                                              "button",
                                                                              {
                                                                                staticClass:
                                                                                  "btn btn-success"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "i",
                                                                                  {
                                                                                    staticClass:
                                                                                      "fa fa-check"
                                                                                  }
                                                                                )
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        _c(
                                                                          "button",
                                                                          {
                                                                            staticClass:
                                                                              "btn btn-primary",
                                                                            on: {
                                                                              click: function(
                                                                                $event
                                                                              ) {
                                                                                return _vm.rmSubRota(
                                                                                  list.id
                                                                                )
                                                                              }
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "i",
                                                                              {
                                                                                staticClass:
                                                                                  "fas fa-trash"
                                                                              }
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ])
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          0
                                                        ),
                                                        _vm._v(" "),
                                                        _c("tfoot", [
                                                          _c("tr", [
                                                            _c("td"),
                                                            _vm._v(" "),
                                                            _c("td"),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-primary"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                            Km extra: " +
                                                                    _vm._s(
                                                                      _vm.totalSubRota
                                                                    ) +
                                                                    "\n                                                        "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("td"),
                                                            _vm._v(" "),
                                                            _c("td"),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _c(
                                                                "button",
                                                                {
                                                                  staticClass:
                                                                    "btn btn-primary",
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.atualizakmExtra(
                                                                        _vm.roteiro_id
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                                Concluir SubRota\n                                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ])
                                                          ])
                                                        ])
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row" })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-md-4" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.busca,
                                              expression: "busca"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            placeholder: " informe um endereço",
                                            type: "text"
                                          },
                                          domProps: { value: _vm.busca },
                                          on: {
                                            keyup: _vm.getAddress,
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.busca = $event.target.value
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.listaBusca.length > 0
                                          ? _c(
                                              "div",
                                              { staticClass: "list-group" },
                                              _vm._l(_vm.listaBusca, function(
                                                list,
                                                index
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass:
                                                      "list-group-item"
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.addMarker(
                                                              list.coordenadas
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(index + 1) +
                                                            " - " +
                                                            _vm._s(
                                                              list.endereco
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              }),
                                              0
                                            )
                                          : _vm._e()
                                      ])
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row mt-3",
              staticStyle: { width: "100%", height: "600px" }
            },
            [
              _c(
                "div",
                { staticClass: "center-block col-md-12" },
                [
                  _c(
                    "l-map",
                    {
                      ref: "rota",
                      staticStyle: { height: "70%" },
                      attrs: { zoom: _vm.zoom, center: _vm.inicio }
                    },
                    [
                      _c("l-tile-layer", {
                        attrs: { url: _vm.url, attribution: _vm.attribution }
                      }),
                      _vm._v(" "),
                      _c("v-geosearch", {
                        attrs: { options: _vm.geosearchOptions }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.markers, function(marker) {
                        return _c(
                          "l-marker",
                          {
                            key: marker.id,
                            attrs: {
                              draggable: marker.draggable,
                              "lat-lng": marker.position
                            }
                          },
                          [_c("l-popup", { attrs: { content: marker.title } })],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Resumo da rota", size: "xl" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "primary" },
                      on: { click: _vm.salvaRota }
                    },
                    [_vm._v("Confirmar")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "danger" },
                      on: {
                        click: function($event) {
                          _vm.modalAddRota = false
                        }
                      }
                    },
                    [_vm._v("Cancelar")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalAddRota,
            callback: function($$v) {
              _vm.modalAddRota = $$v
            },
            expression: "modalAddRota"
          }
        },
        [
          _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { staticClass: "list-group" }, [
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total de Combustível: R$ " +
                            _vm._s(_vm.totalCombustivel.toFixed(2)) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.totalLitros.toFixed(2)) +
                              " Litros\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total Hospedagem : R$ " +
                            _vm._s(_vm.totalHospedagem) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.parametros.hospedagem) +
                              " a diária\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item" }, [
                        _vm._v(
                          "\n                                Total Alimentação : R$ " +
                            _vm._s(_vm.totalAlimentacao) +
                            "\n                                "
                        ),
                        _c("small", { staticClass: "text-danger" }, [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(_vm.parametros.alimentacao) +
                              " a diária\n                                "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "list-group-item bg bg-secondary" },
                        [
                          _vm._v(
                            "\n                                Total Pedágio : R$ " +
                              _vm._s(_vm.totalPedagio) +
                              "\n                            "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-group-item active" }, [
                        _vm._v(
                          "\n                                Total : R$ " +
                            _vm._s(
                              (_vm.valorTOTAL + _vm.totalPedagio).toFixed(2)
                            ) +
                            "\n                            "
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-3" }, [
                  _c("table", { staticClass: "table-stripe table-hover" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("Rota")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Endereco")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Cidade")]),
                        _vm._v(" "),
                        _c("th", [_vm._v("Pedágio")]),
                        _vm._v(" "),
                        _c("th")
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.orderedUsers, function(rota, i) {
                        return _c("tr", { key: i }, [
                          _c("td", [_vm._v(_vm._s(i + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.endereco))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(rota.cidade))]),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: [
                                      "#.##",
                                      "##.##",
                                      "###.##",
                                      "###.##"
                                    ],
                                    expression:
                                      "['#.##', '##.##', '###.##', '###.##']"
                                  },
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: rota.pedagio,
                                    expression: "rota.pedagio"
                                  },
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !rota.showInput,
                                    expression: "!rota.showInput"
                                  }
                                ],
                                attrs: { type: "text" },
                                domProps: { value: rota.pedagio },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      rota,
                                      "pedagio",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            rota.showInput
                              ? _c("span", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(rota.pedagio) +
                                      "\n                                    "
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              !rota.showInput
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "success" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addPedagio(rota.pedagio, i)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fa fa-check" })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              rota.showInput
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          return _vm.addPedagio(0, i)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-window-close"
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c("tr", { staticClass: "text-primary" }, [
                        _c("td", [_vm._v("-")]),
                        _vm._v(" "),
                        _c("td", [_vm._v("Total Km " + _vm._s(_vm.totalKM))]),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td")
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dca72de", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dca72de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/EditRota.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6dca72de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/rotas/EditRota.vue
// module chunks = 2